<template>
  <div>
    <div class="p-grid">
        <div class="p-col-12">
        <div class="card">
            
            <h4>List of All Sales Data</h4>
            
        </div>
        </div>
    </div>

    

    <DataTable :value="sales" class="p-datatable-gridlines" dataKey="id" ref="production-job-table"
    :rowHover="true" :paginator="true" :rows="25" :lazy="true" :totalRecords="totalRecords"
    :resizableColumns="true"
    columnResizeMode="expand"
    :loading="requesting"
    @page="onPage($event)" 
    responsiveLayout="scroll" :rowsPerPageOptions="[25,50,100]" 
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" 
    >
        <template #loading> Loading Sales data. Please wait. </template>
        <template #empty>
            No Sales Data found.
        </template>
        <Column field="branchCode" header="Branch Code" :sortable="true"/> 
        <Column field="branchName" header="Branch"/> 
        <Column field="tasCode" header="TAS Code"/> 
        <Column field="salesExecName" header="Sales Exec"/> 
        <Column field="prevYearSales" header="Previous Year Sales"/> 
        <Column field="currYearSales" header="Current Year Sales"/> 
    </DataTable>

    <div class="flex justify_space_between my-1">
      <div>
      </div>
      <div 
        style="width: 250px; display: flex; justify-content: flex-end;" 
      >
        <ProgressSpinner
          v-if="makingExport"
          style="width:100%; height:25px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Export Sales Data to Excel"
          icon="pi pi-external-link"
          style="width: 210px;"
          @click="exportData"
        />
      </div>
    </div>
  </div>
</template>

<script>

import SalesService from '@/service/SalesService'

// import SalesForcastTableForLazyLoxadingWithResize from '../universalComponents/salesForcast/SalesForcastTableForLazyLoadingWithResize.vue'

export default {
  components: {

  },
  created() {

    this.setupComponent()
  },
  data: () => ({
    salesService: new SalesService(),
    sales: [], // For whole data set
    sale: {},
   
    requesting: false,
    tableKey1: 0,

    searchText: '',
    totalRecords: null,
    totalPages: null,
    currentPage: 1,
    rows: 25,
    firstRequesting: true,
    forceReload: false,

    sendingRequest: false,
    submitted: false,
    selectedRows: [],

    makingExport: false,
  }),
  methods: {
        setupComponent() {
            this.getDataFromSource(1, 50)
        },
        async getDataFromSource(pageNo, pageSize) {
            try {
                this.requesting = true
                let response = await this.salesService.getAllSalesData(pageNo, pageSize)
                this.sales = response.data
                this.totalRecords = parseInt(response.headers.reccount)
            }
            catch(e) {
                this.$toast.add({
                severity: "error",
                detail: "Error fetching Sales!",
                life: 3000,
            })
            }
            finally {
                this.requesting = false
            }
        },
        exportData() {
            import('@/service/Export2Excel').then(excel => {
                
                this.makingExport = true
                this.salesService.getAllSalesData()
                .then(response => {
                    // 

                    if (response.data) {
                    const tHeader = [
                        'Branch Id',
                        'Branch Code',
                        'Branch Name',
                        'Customer Id',
                        'Tas Code',
                        'Active',
                        'MainBranch?',
                        'Cust Branch Id',
                        'Sales Exec Id',
                        'Sales Exec Name',
                        'Prev Year Jan Forecast',
                        'Prev Year Jan Sales',
                        'Curr Year Jan Forecast',
                        'Curr Year Jan Sales',
                        'Prev Year Feb Forecast',
                        'Prev Year Feb Sales',
                        'Curr Year Feb Forecast',
                        'Curr Year Feb Sales',
                        'Prev Year Mar Forecast',
                        'Prev Year Mar Sales',
                        'Curr Year Mar Forecast',
                        'Curr Year Mar Sales',
                        'Prev Year Apr Forecast',
                        'Prev Year Apr Sales',
                        'Curr Year Apr Forecast',
                        'Curr Year Apr Sales',
                        'Prev Year May Forecast',
                        'Prev Year May Sales',
                        'Curr Year May Forecast',
                        'Curr Year May Sales',
                        'Prev Year Jun Forecast',
                        'Prev Year Jun Sales',
                        'Curr Year Jun Forecast',
                        'Curr Year Jun Sales',
                        'Prev Year Jul Forecast',
                        'Prev Year Jul Sales',
                        'Curr Year Jul Forecast',
                        'Curr Year Jul Sales',
                        'Prev Year Aug Forecast',
                        'Prev Year Aug Sales',
                        'Curr Year Aug Forecast',
                        'Curr Year Aug Sales',
                        'Prev Year Sept Forecast',
                        'Prev Year Sept Sales',
                        'Curr Year Sept Forecast',
                        'Curr Year Sept Sales',
                        'Prev Year Oct Forecast',
                        'Prev Year Oct Sales',
                        'Curr Year Oct Forecast',
                        'Curr Year Oct Sales',
                        'Prev Year Nov Forecast',
                        'Prev Year Nov Sales',
                        'Curr Year Nov Forecast',
                        'Curr Year Nov Sales',
                        'Prev Year Dec Forecast',
                        'Prev Year Dec Sales',
                        'Curr Year Dec Forecast',
                        'Curr Year Dec Sales',
                        'Prev Year Forecast',
                        'Prev Year Sales',
                        'Curr Year Forecast',
                        'Curr Year Sales'
                    ]
                    const filterVal = [
                        'branchId',
                        'branchCode',
                        'branchName',
                        'customerId',
                        'tasCode',
                        'active',
                        'mainBranch',
                        'custBranchId',
                        'salesExecId',
                        'salesExecName',
                        'prevYearJanForecast',
                        'prevYearJanSales',
                        'currYearJanForecast',
                        'currYearJanSales',
                        'prevYearFebForecast',
                        'prevYearFebSales',
                        'currYearFebForecast',
                        'currYearFebSales',
                        'prevYearMarForecast',
                        'prevYearMarSales',
                        'currYearMarForecast',
                        'currYearMarSales',
                        'prevYearAprForecast',
                        'prevYearAprSales',
                        'currYearAprForecast',
                        'currYearAprSales',
                        'prevYearMayForecast',
                        'prevYearMaySales',
                        'currYearMayForecast',
                        'currYearMaySales',
                        'prevYearJunForecast',
                        'prevYearJunSales',
                        'currYearJunForecast',
                        'currYearJunSales',
                        'prevYearJulForecast',
                        'prevYearJulSales',
                        'currYearJulForecast',
                        'currYearJulSales',
                        'prevYearAugForecast',
                        'prevYearAugSales',
                        'currYearAugForecast',
                        'currYearAugSales',
                        'prevYearSeptForecast',
                        'prevYearSeptSales',
                        'currYearSeptForecast',
                        'currYearSeptSales',
                        'prevYearOctForecast',
                        'prevYearOctSales',
                        'currYearOctForecast',
                        'currYearOctSales',
                        'prevYearNovForecast',
                        'prevYearNovSales',
                        'currYearNovForecast',
                        'currYearNovSales',
                        'prevYearDecForecast',
                        'prevYearDecSales',
                        'currYearDecForecast',
                        'currYearDecSales',
                        'prevYearForecast',
                        'prevYearSales',
                        'currYearForecast',
                        'currYearSales'
                    ]

                    const data = this.formatJson(filterVal, response.data)
                    // 
                    let a = new Date(), date = a.getDate() + '_' + a.getMonth() + 1 + '_' + a.getFullYear() + '-' + a.getHours() + '_' + a.getMinutes() + '_' + a.getSeconds()

                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: 'AllSalesData' + '-' + date,
                        autoWidth: true,
                        bookType: 'xlsx'
                    })
                    }

                    this.makingExport = false
                })
                .catch(err => {
                    this.makingExport = false
                    
                    this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: `Error while getting sales Data for exporting`,
                    life: 5000,
                    })
                })
                
                })
        },
        onPage(event) {
            this.getDataFromSource(event.page+1, event.rows)
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                
                let a = v, parts = j.split('.')
                parts.forEach(part => {
                if (a) {
                    a = a[part]
                }
                })
                if (a === true) {
                return 'Yes'
                } else if (a === false) {
                return 'No'
                } else {
                return a
                }
                
            }))
        }
    }


  }
</script>

<style scoped lang="scss">

.greenBackground {
  background-color: #5c9434;
  width: 83px; 
}

.defaultBackground {
  // background-color: #2494f4;
  background-color: #248cc4;
  width: 50px; 
}

</style>